import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const parLevelConfig = {
  /* ------------------------------- GET ---------------------------------- */

  getAllParLevels: {
    key: "getAllParLevels",
    url: "/api/v1/par-levels",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getParLevelsByRoomType: {
    key: "getParLevelsByRoomType",
    url: (data) => {
      const base = `/api/v1/par-levels/by-room-type/${data.roomTypeId}`;
      return data.isDeleted ? `${base}?isDeleted=${data.isDeleted}` : base;
    },
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  setParLevel: {
    key: "setParLevel",
    url: "/api/v1/par-levels",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllParLevels", "getParLevelsByRoomType"],
      onSuccessMessage: "Par level set successfully",
      onErrorMessage: "Failed to set par level",
    },
  },

  /* ------------------------------- PUT ---------------------------------- */

  updateParLevel: {
    key: "updateParLevel",
    url: (data) => `/api/v1/par-levels/${data.parLevelId || data.id}`,
    method: "PUT",
    options: {
      retry: 2,
      invalidateKeys: ["getAllParLevels", "getParLevelsByRoomType", "getRoomInventory"],
      onSuccessMessage: "Par level updated successfully",
      onErrorMessage: "Failed to update par level",
    },
  },

  /* ------------------------------- DELETE ---------------------------------- */

  deleteParLevel: {
    key: "deleteParLevel",
    url: (data) => `/api/v1/par-levels/${data.parLevelId || data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getAllParLevels", "getParLevelsByRoomType", "getRoomInventory"],
      onSuccessMessage: "Par level deleted successfully",
      onErrorMessage: "Failed to delete par level",
    },
  },

  /* ------------------------------- POST (restore) ---------------------------------- */

  restoreParLevel: {
    key: "restoreParLevel",
    url: (data) => `/api/v1/par-levels/${data.parLevelId || data.id}/restore`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllParLevels", "getParLevelsByRoomType", "getRoomInventory"],
      onSuccessMessage: "Par level restored successfully",
      onErrorMessage: "Failed to restore par level",
    },
  },
};
